// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa521468","453":"6ae5fd4b","455":"8f71c21b"}[chunkId] + ".chunk.js";
};